import React from 'react'

class Error extends React.PureComponent {
    state = {
        hasError: null
    }

    componentDidCatch(error, info)
    {
        this.setState({ hasError: true })
        //Add DTM Error event
        if (typeof _satellite !== 'undefined') window._satellite.track('cbTrack.appError', {
            "Error": error,
            "Info": info
        })
    }

    render() {
        return this.state.hasError ?
          (
            <div className="container">
              <div className="row">
                <div className="cb-panel-white">
                  <div className="col-xs-12">
                    <div className="alert alert-danger cb-alert-heading" role="alert">
                      <h3>Sorry! Something went wrong... Please refresh or check back later.</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div> )
          : (this.props.children)
    }
}

export default Error